import React from "react";
import "./../../assets/sass/style.css";
import PrismaComponent from "./../../Components/prismaComponent";

const PrismaPage = () => {
  return (
    <>
      <div className="main-wrapper">
        <div className="content-wrapper">
          <PrismaComponent />
        </div>
      </div>
    </>
  );
};

export default PrismaPage;
